import React from "react";
import { StatusButtonPresenter, PresenterProps } from "./StatusButton";

type Props = PresenterProps;

export const StatusButton: React.FC<Props> = (props) => {
  return <StatusButtonPresenter {...props}></StatusButtonPresenter>;
};
